import React from "react";
import { useNavigate } from "react-router-dom";
function ErrorSection(props) {
  const { btnTitle, btnAction } = props;
  let navigate = useNavigate();
  return (
    <section className="error-box">
         <svg
                    width="400"
                    height="419"
                    viewBox="0 0 400 419"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <g clip-path="url(#clip0_408_63632)">
                        <path
                            d="M154.734 418.558C240.191 418.558 309.467 406.32 309.467 391.223C309.467 376.126 240.191 363.887 154.734 363.887C69.2766 363.887 0 376.126 0 391.223C0 406.32 69.2766 418.558 154.734 418.558Z"
                            fill="#EAECF0"
                        />
                        <path
                            d="M248.777 302.445C332.295 302.445 400 234.74 400 151.223C400 67.7046 332.295 0 248.777 0C165.26 0 97.5549 67.7046 97.5549 151.223C97.5549 234.74 165.26 302.445 248.777 302.445Z"
                            fill="#EAECF0"
                        />
                        <path
                            opacity="0.05"
                            d="M248.778 276.061C317.724 276.061 373.617 220.169 373.617 151.222C373.617 82.2757 317.724 26.3833 248.778 26.3833C179.831 26.3833 123.938 82.2757 123.938 151.222C123.938 220.169 179.831 276.061 248.778 276.061Z"
                            fill="black"
                        />
                        <path
                            opacity="0.05"
                            d="M248.777 253.539C305.285 253.539 351.094 207.731 351.094 151.223C351.094 94.7149 305.285 48.9062 248.777 48.9062C192.27 48.9062 146.461 94.7149 146.461 151.223C146.461 207.731 192.27 253.539 248.777 253.539Z"
                            fill="black"
                        />
                        <path
                            opacity="0.05"
                            d="M248.777 224.582C289.293 224.582 322.137 191.738 322.137 151.223C322.137 110.708 289.293 77.8638 248.777 77.8638C208.262 77.8638 175.418 110.708 175.418 151.223C175.418 191.738 208.262 224.582 248.777 224.582Z"
                            fill="black"
                        />
                        <path
                            d="M98.8941 164.756C98.8941 164.756 87.005 198.222 92.2891 210.111C97.5731 222 105.94 233.449 105.94 233.449C105.94 233.449 102.857 166.958 98.8941 164.756Z"
                            fill="#D0CDE1"
                        />
                        <path
                            opacity="0.1"
                            d="M98.8941 164.756C98.8941 164.756 87.005 198.222 92.2891 210.111C97.5731 222 105.94 233.449 105.94 233.449C105.94 233.449 102.857 166.958 98.8941 164.756Z"
                            fill="black"
                        />
                        <path
                            d="M107.261 242.256C107.261 242.256 106.38 250.622 105.94 251.062C105.499 251.503 106.38 252.383 105.94 253.704C105.499 255.025 105.059 256.787 105.94 257.227C106.82 257.667 101.096 296.417 101.096 296.417C101.096 296.417 87.005 314.911 92.7294 343.974L94.4908 373.476C94.4908 373.476 108.141 374.357 108.141 369.513C108.141 369.513 107.261 363.789 107.261 361.147C107.261 358.505 109.462 358.505 108.141 357.184C106.82 355.863 106.82 354.982 106.82 354.982C106.82 354.982 109.022 353.221 108.582 352.78C108.141 352.34 112.545 321.076 112.545 321.076C112.545 321.076 117.388 316.232 117.388 313.59V310.948C117.388 310.948 119.59 305.224 119.59 304.784C119.59 304.343 131.479 277.483 131.479 277.483L136.323 296.858L141.607 324.599C141.607 324.599 144.249 349.698 149.533 359.386C149.533 359.386 158.78 391.09 158.78 390.209C158.78 389.329 174.192 387.127 173.752 383.164C173.311 379.201 164.504 323.718 164.504 323.718L166.706 241.375L107.261 242.256Z"
                            fill="#2F2E41"
                        />
                        <path
                            d="M95.3715 371.274C95.3715 371.274 83.4823 394.612 91.4084 395.493C99.3345 396.374 102.417 396.374 105.94 392.851C107.865 390.925 111.765 388.341 114.905 386.394C116.766 385.259 118.269 383.623 119.242 381.673C120.215 379.723 120.619 377.538 120.407 375.369C120.175 373.215 119.37 371.439 117.388 371.274C112.104 370.834 105.94 365.99 105.94 365.99L95.3715 371.274Z"
                            fill="#2F2E41"
                        />
                        <path
                            d="M160.982 388.448C160.982 388.448 149.093 411.786 157.019 412.666C164.945 413.547 168.027 413.547 171.55 410.024C173.476 408.098 177.376 405.514 180.516 403.568C182.376 402.433 183.879 400.796 184.852 398.846C185.825 396.896 186.229 394.711 186.017 392.542C185.785 390.388 184.98 388.613 182.999 388.448C177.715 388.007 171.55 383.164 171.55 383.164L160.982 388.448Z"
                            fill="#2F2E41"
                        />
                        <path
                            d="M148.416 126.564C158.639 126.564 166.926 118.277 166.926 108.054C166.926 97.8312 158.639 89.5439 148.416 89.5439C138.193 89.5439 129.906 97.8312 129.906 108.054C129.906 118.277 138.193 126.564 148.416 126.564Z"
                            fill="#FFB8B8"
                        />
                        <path
                            d="M136.517 114.136C136.517 114.136 123.295 138.463 122.238 138.463C121.18 138.463 146.036 146.396 146.036 146.396C146.036 146.396 152.912 123.126 153.969 121.011L136.517 114.136Z"
                            fill="#FFB8B8"
                        />
                        <path
                            d="M156.799 140.757C156.799 140.757 130.378 126.226 127.736 126.667C125.094 127.107 96.9127 151.766 97.353 161.894C97.7933 172.021 101.316 188.754 101.316 188.754C101.316 188.754 102.637 235.43 105.279 235.87C107.921 236.311 104.839 244.237 105.719 244.237C106.6 244.237 167.367 244.237 167.807 242.916C168.247 241.595 156.799 140.757 156.799 140.757Z"
                            fill="#D0CDE1"
                        />
                        <path
                            d="M171.55 245.338C171.55 245.338 179.916 270.878 172.871 269.997C165.826 269.116 162.743 247.98 162.743 247.98L171.55 245.338Z"
                            fill="#FFB8B8"
                        />
                        <path
                            d="M149.093 139.216C149.093 139.216 132.8 142.739 135.442 164.756C138.084 186.773 142.928 208.79 142.928 208.79L159.22 244.457L160.982 251.062L172.871 247.98L164.064 196.901C164.064 196.901 160.982 142.299 157.019 140.537C154.52 139.472 151.802 139.019 149.093 139.216Z"
                            fill="#D0CDE1"
                        />
                        <path
                            opacity="0.1"
                            d="M139.185 208.13L159.441 244.237L142.375 206.189L139.185 208.13Z"
                            fill="black"
                        />
                        <path
                            d="M166.844 102.604L166.906 101.189L169.719 101.889C169.689 101.435 169.561 100.993 169.343 100.594C169.126 100.194 168.824 99.8463 168.459 99.5746L171.456 99.4071C168.941 95.833 165.727 92.8058 162.01 90.5083C158.292 88.2108 154.148 86.6906 149.826 86.0396C143.343 85.0999 136.124 86.4597 131.678 91.2712C129.522 93.605 128.167 96.5728 127.203 99.6006C125.428 105.177 125.066 111.825 128.768 116.358C132.53 120.965 139.101 121.867 145.022 122.437C147.105 122.638 149.288 122.825 151.218 122.016C151.433 119.802 151.15 117.568 150.389 115.477C150.072 114.83 149.92 114.115 149.948 113.395C150.211 111.633 152.561 111.19 154.325 111.428C156.09 111.666 158.213 112.03 159.372 110.678C160.171 109.747 160.124 108.391 160.23 107.169C160.518 103.842 166.814 103.301 166.844 102.604Z"
                            fill="#2F2E41"
                        />
                        <g id="erropath">
                        <path
                            d="M280.376 394.984C292.288 394.984 301.944 385.328 301.944 373.417C301.944 361.506 292.288 351.85 280.376 351.85C268.465 351.85 258.809 361.506 258.809 373.417C258.809 385.328 268.465 394.984 280.376 394.984Z"
                            fill="#6941C6"
                        />
                        <path
                            d="M27.0847 387.461C38.9961 387.461 48.6521 377.805 48.6521 365.894C48.6521 353.982 38.9961 344.326 27.0847 344.326C15.1734 344.326 5.51733 353.982 5.51733 365.894C5.51733 377.805 15.1734 387.461 27.0847 387.461Z"
                            fill="#6941C6"
                        />
                        <path
                            d="M27.0847 352.853C35.672 352.853 42.6333 345.891 42.6333 337.304C42.6333 328.717 35.672 321.755 27.0847 321.755C18.4975 321.755 11.5361 328.717 11.5361 337.304C11.5361 345.891 18.4975 352.853 27.0847 352.853Z"
                            fill="#6941C6"
                        />
                        <path
                            d="M27.0845 324.263C33.1787 324.263 38.119 319.323 38.119 313.229C38.119 307.135 33.1787 302.194 27.0845 302.194C20.9904 302.194 16.05 307.135 16.05 313.229C16.05 319.323 20.9904 324.263 27.0845 324.263Z"
                            fill="#6941C6"
                        />
                        </g>
                       
                    </g>
                    <defs>
                        <clipPath id="clip0_408_63632">
                            <rect width="400" height="418.558" fill="white" />
                        </clipPath>
                    </defs>
                </svg>
      <div className="error-msgs">Nothing here, yet.</div>
      <div className="button-design d-flex justify-content-center">
        <button type="button" className="startcourse-btn" onClick={()=> btnAction ==="events" ? navigate("/learn/events") : navigate(btnAction) }>
          {btnTitle ? btnTitle : "Explore courses"}
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
          >
            <path
              d="M4.16602 9.99981H15.8327M15.8327 9.99981L9.99935 4.16648M15.8327 9.99981L9.99935 15.8331"
              stroke="#6941C6"
              strokeWidth="1.66667"
              stroke-linecap="round"
              stroke-linejoin="round"
            ></path>
          </svg>
        </button>
      </div>
    </section>
  );
}

export default ErrorSection;
